import { render } from "./TitleComp.vue?vue&type=template&id=15c5ab76"
import script from "./TitleComp.vue?vue&type=script&lang=js"
export * from "./TitleComp.vue?vue&type=script&lang=js"

import "./TitleComp.vue?vue&type=style&index=0&id=15c5ab76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__